<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-faded position-absolute w-100 topmenu pr-0">
      <div class="container"></div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "TopMenu",
  computed: {},
  props: {
    mobileMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>
